module.exports = new __parcel__URL__("7328.267cd791.jpg").toString();